// src/pages/Home.js
import React from 'react';

function InglesPresencial() {
  return (
    <section className="p-8 text-center">
      <h1 className="text-3xl font-bold">Inglés Presencial</h1>
    </section>
  );
}

export default InglesPresencial;
